export default __webpack_public_path__ + "static/3-0c4db4e8245aa61024a1832cd1e23f52.png";